import React, { useEffect, useMemo, useState } from 'react';
import { Input } from 'rsuite';
import { Button, Modal } from '@nsi-advisory-services/components';

const formatRequestSummary = (request) => {
  if (!request) return '';
  const type = request.request_type ? String(request.request_type) : 'time off';
  const who = request.first_name || request.last_name ? `${request.first_name || ''} ${request.last_name || ''}`.trim() : '';
  const start = request.start_date ? String(request.start_date).slice(0, 10) : '';
  const end = request.end_date ? String(request.end_date).slice(0, 10) : '';
  const range = start && end ? `${start} → ${end}` : start || end;
  return `${who ? `${who} • ` : ''}${type}${range ? ` • ${range}` : ''}`;
};

export default function ApprovalActionModal({
  open,
  onClose,
  request,
  action,
  onSubmit,
  loading,
  summary,
}) {
  const isApprove = String(action).toLowerCase() === 'approve';
  const title = isApprove ? 'Approve Request' : 'Reject Request';
  const submitLabel = isApprove ? 'Approve' : 'Reject';
  const submitVariant = isApprove ? 'primary' : 'danger-solid';

  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  const resolvedSummary = useMemo(() => summary || formatRequestSummary(request), [summary, request]);

  const canSubmit = reason.trim().length > 0;

  return (
    <Modal open={open} onClose={onClose} size="sm">
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {resolvedSummary ? <div className="text-muted" style={{ marginBottom: 12 }}>{resolvedSummary}</div> : null}
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Reason (required)</div>
        <Input
          as="textarea"
          rows={4}
          placeholder={isApprove ? 'Enter approval reason…' : 'Enter rejection reason…'}
          value={reason}
          onChange={(v) => setReason(v)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant={submitVariant}
          disabled={!canSubmit}
          loading={!!loading}
          onClick={() => onSubmit?.(reason.trim())}
        >
          {submitLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
